import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Success: FC<ISvG> = ({ fill = "#27ae60" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.967"
      height="20.05"
      viewBox="0 0 20.967 20.05"
    >
      <g transform="translate(0 0)">
        <path
          d="M19.2,19.536a.847.847,0,0,0-.847.847v.853a8.331,8.331,0,0,1-8.331,8.326h0a8.331,8.331,0,0,1,0-16.662h0a8.279,8.279,0,0,1,3.386.721.847.847,0,0,0,.689-1.547,9.961,9.961,0,0,0-4.074-.868h-.006a10.025,10.025,0,0,0-.006,20.05h.006A10.025,10.025,0,0,0,20.05,21.236v-.854A.847.847,0,0,0,19.2,19.536Z"
          transform="translate(0 -11.206)"
          fill={fill}
        />
      </g>
      <g transform="translate(6.425 0.923)">
        <g transform="translate(0 0)">
          <path
            d="M171.174,33.994a.847.847,0,0,0-1.2,0l-9.5,9.5-2.154-2.154a.847.847,0,0,0-1.2,1.2l2.753,2.753a.847.847,0,0,0,1.2,0l10.1-10.1A.847.847,0,0,0,171.174,33.994Z"
            transform="translate(-156.879 -33.746)"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
};

export default memo(Success);
